module.exports = __webpack_public_path__ + "img/building.bf2664ca.png";